import { RefObject, useEffect, useMemo, useState } from "react";
import { useAuth } from "../../../global-components/src";
import { fetchUsers } from "../../../services/user";
import UserSearch from "./User/User";
import { debounce } from "lodash";
import "./style.css"
import { UserSearchLoadin } from "./User/UserSearchLoading";
import { UserX } from "lucide-react";

interface Props {
  text: string;
  setText: (value: string) => void;
  textareaRef: RefObject<HTMLTextAreaElement | null>;
  bottom?: string | number; 
}

export default function PreviewSearch({ text, setText, textareaRef, bottom }: Props){
    const { token } = useAuth();
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [suggestions, setSuggestions] = useState<any>([]);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [loading, setLoading] = useState(false);

    // Cria função de busca com debounce (300ms)
  const debouncedCheckAt = useMemo(
        () =>
        debounce(async (textValue: string) => {
            if (!textareaRef.current) return;

            const cursorIndex = textareaRef.current.selectionStart;
            const textBeforeCursor = textValue.slice(0, cursorIndex);
            const match = textBeforeCursor.match(/@([a-zA-Z0-9_]+)$/);

            if (match) {
                const username = match[1];
                const response = await fetchUsers(username, token);

                if (response?.users) setSuggestions(response.users);
                else setSuggestions([]);

                const textarea = textareaRef.current;

                // Pega o container pai (para posicionamento relativo)
                const container = textarea.parentElement;
                const rect = textarea.getBoundingClientRect();

                // Cria o elemento "fantasma" para medir posição do cursor
                const div = document.createElement("div");
                const style = window.getComputedStyle(textarea);

                // Copia o estilo do textarea para o div
                for (const prop of style) {
                div.style.setProperty(prop, style.getPropertyValue(prop));
                }
                div.style.position = "absolute";
                div.style.visibility = "hidden";
                div.style.whiteSpace = "pre-wrap";
                div.style.wordWrap = "break-word";
                div.style.width = `${textarea.offsetWidth}px`;
                div.textContent = textBeforeCursor;

                // Adiciona o marcador invisível
                const span = document.createElement("span");
                span.textContent = "\u200b";
                div.appendChild(span);

                container?.appendChild(div); // agora dentro do container
                const spanRect = span.getBoundingClientRect();
                const containerRect = container?.getBoundingClientRect();

                // Posição relativa ao container pai
                setPosition({
                top: spanRect.top - (containerRect?.top || 0) + 20, // +20px pra aparecer logo abaixo da linha
                left: spanRect.left - (containerRect?.left || 0),
                });

                container?.removeChild(div);

                setShowSuggestions(true);
            } else {
                setShowSuggestions(false);
            }
            setLoading(false);
        }, 2000),
        [token, textareaRef, setSuggestions, setShowSuggestions]
    );

    useEffect(() => {
        if (!textareaRef.current) return;
        const cursorIndex = textareaRef.current.selectionStart;
        const textBeforeCursor = text.slice(0, cursorIndex);
        const match = textBeforeCursor.match(/@([a-zA-Z0-9_]+)$/);
        if(!match){
            setShowSuggestions(false);
            return;
        }
        setLoading(true);
        setShowSuggestions(true);
        debouncedCheckAt(text);
        // Cancelar debounce quando desmontar
        return () => {
            debouncedCheckAt.cancel();
        };
    }, [text, debouncedCheckAt]);

    const handleSelectUserLocal = (userName: string) => {
        if (!textareaRef.current) return;

        const textarea = textareaRef.current;
        const cursorIndex = textarea.selectionStart;

        // Substitui o "@parcial" pelo nome completo
        const before = text.slice(0, cursorIndex).replace(/@([a-zA-Z0-9_]*)$/, `@${userName} `);
        const after = text.slice(cursorIndex);
        const newText = before + after;

        setText(newText);
        setShowSuggestions(false);

        // Calcula nova posição do cursor (logo após o nome inserido)
        const newCursorPos = before.length;

        // Reposiciona o foco e o cursor corretamente
        requestAnimationFrame(() => {
            textarea.focus();
            textarea.setSelectionRange(newCursorPos, newCursorPos);
        });
    };


    const dropdownStyle: React.CSSProperties = {
        left: 5,
        right: 5,
        bottom: bottom,
    };

    return (
        <>
            {showSuggestions && (
                <div className="preview-users-suggestions"  style={dropdownStyle} >
                    <div className="scroll-fino">
                        <UserSearchLoadin loading={loading} />
                            {suggestions.map((u: any) => (
                                <UserSearch clasImgAccount="img-account-search img-preview-marcar" user={u} hideFollowUser onClick={() => handleSelectUserLocal(u.user_name)}/>
                            ))}

                            {!suggestions.length ? (
                                <div className="user-select-none row " style={{display: "flex", alignItems: "center", margin: 0, height: "100%" , padding: "50px 20px"}}>
                                    <span className="span-empty">
                                        <UserX className="icon-empty" />
                                        <h3 className="w-100 text-center">Nenhum usuário encontrado</h3>
                                    </span>
                                </div>
                            ): null}
                        </div>
                </div>
                )}
        </>
    )
}